import { render, staticRenderFns } from "./WalletReceiveModal.vue?vue&type=template&id=91d813da&"
import script from "./WalletReceiveModal.vue?vue&type=script&lang=js&"
export * from "./WalletReceiveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports